export const selectPromoError = (state) => state.promoReducer.error;
